
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Options({})
  export default class ModalComponent extends Vue {
    @Prop() open: boolean;
    @Prop({ default: true }) showCloseButton: boolean;
    @Prop({ default: false }) showHeader: boolean;

    private handleKeyup(event) {
      if (event.keyCode === 27) {
        this.close();
      }
    }

    close() {
      this.$emit('close');
    }

    mounted() {
      document.addEventListener('keyup', this.handleKeyup);
    }
    unmounted() {
      document.removeEventListener('keyup', this.handleKeyup);
    }
  }
